import { render, staticRenderFns } from "./OrgUnitChart.vue?vue&type=template&id=332165d4&scoped=true"
import script from "./OrgUnitChart.vue?vue&type=script&lang=js"
export * from "./OrgUnitChart.vue?vue&type=script&lang=js"
import style0 from "./OrgUnitChart.vue?vue&type=style&index=0&id=332165d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332165d4",
  null
  
)

export default component.exports